import { render, staticRenderFns } from "./SdsCurrentFilter.vue?vue&type=template&id=33c54652&scoped=true"
import script from "./SdsCurrentFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./SdsCurrentFilter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SdsCurrentFilter.vue?vue&type=style&index=0&id=33c54652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c54652",
  null
  
)

export default component.exports